import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatTableDataSource } from '@angular/material/table';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { LmsService } from "../../_Lms/services/lms.service";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { DialogService } from "../../Shared/dialog.service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
declare var $: any;

@Component({
  selector: 'app-general-voucher-import',
  templateUrl: './general-voucher-import.component.html',
  styleUrls: ['./general-voucher-import.component.scss']
})
export class GeneralVoucherImportComponent implements OnInit {
  mode: 'LoanToAccount' | 'LoanToLoan' | 'AccountToAccount' |
    'ReceiptLoan' | 'ReceiptAccountToAccount' |
    'PaymentLoanToAccount' | 'PaymentAccountToAccount' |
    'PartnerReceipt' | 'PartnerPayment' |
    'PartnerJournalLoanToAccount' | 'PartnerJournalLoanToLoan' = 'LoanToAccount';
  Voucher_Tag: any = 'CASH';
  accountTagDropdown: any = [];
  showSpinner: boolean = false;
  ChargesHeadDropdown: any = [];
  accountHeadDropdown: any = [];
  DRAccountId: any = '';
  Voucher_Mode_of_Payment: any = '';
  Voucher_E_Ref_No: any = '';
  Voucher_E_Transaction_Date: any = '';
  Voucher_Cheque_No: any = '';
  Voucher_Cheque_Date: any = '';
  Voucher_Cheque_Clear_Date: any = '';
  Voucher_Bank_Name: any = '';
  Account_HeadId: any = '';
  Amount: any;
  UnmatchedData: any[] = [];
  UIValidationFailed: any[] = [];
  displayedColumnsUIValidation: string[] = [];
  dataSourceUIValidation: any;
  VoucherDate: any;
  ToDate = new Date();
  Type: any = "CR"
  UnmatcheddisplayedColumns: string[] = [];
  dataSourceUnmatched: any;
  currentUser: any;
  configSuccess: MatSnackBarConfig = {
    panelClass: 'style-success',
    duration: 5000,
    horizontalPosition: 'right',
    verticalPosition: 'top'
  };
  voucherMasterdata: any;
  voucherDetaildata: any;
  dataSourceVoucher: any;
  displayedVoucherColumns: string[] = [];
  displayedAccountingColumns: string[] = [];   // for AccountToAccount preview
  Remarks: any;
  MainPayload: any;
  BranchesList: any = [];
  BranchId: any = '';
  @ViewChild('bulkImportModel') bulkImportModel: any;
  @ViewChild('importFileInput') importFileInput!: ElementRef;
  @ViewChild('paginator') paginator!: MatPaginator;

  constructor(
    private _MasterService: MasterService,
    private dataSharingService: DataSharingService,
    private snackBar: MatSnackBar,
    private dialogService: DialogService,
    private lmsService: LmsService
  ) { }

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("Single Voucher Import");

    this._MasterService.GetProductChargesHeadDropDown().subscribe((result) => {
      this.ChargesHeadDropdown = JSON.parse(JSON.stringify(result));
    });
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.Get_Acc_Accounts_OtherThan_BankCash();
    this.getBranchesList();
    this.Get_Acc_Accounts_By_Tag();
  }
  get modalTitle(): string {
    switch (this.mode) {
      case 'LoanToLoan':
        return 'Loan to Loan Import';
      case 'AccountToAccount':
        return 'Account to Account Import';
      case 'ReceiptLoan':
        return 'Receipt Loan Import';
      case 'ReceiptAccountToAccount':
        return 'Receipt Account to Account Import';
      case 'PaymentLoanToAccount':
        return 'Payment Loan to Account Import';
      case 'PaymentAccountToAccount':
        return 'Payment Account to Account Import';
      case 'PartnerReceipt':
        return 'Partner Receipt Voucher Import';
      case 'PartnerPayment':
        return 'Partner Payment Voucher Import';
      case 'PartnerJournalLoanToAccount':
        return 'Partner Journal Loan to Account Import';
      case 'PartnerJournalLoanToLoan':
        return 'Partner Journal Loan to Loan Import';
      default:
        return 'Loan to Accounts Import';
    }
  }

  getBranchesList() {
    this.lmsService.GetBranches({ Emp_Id: this.currentUser.userId }).subscribe((result) => {
      this.BranchesList = JSON.parse(JSON.stringify(result));
    });
  }

  Get_Acc_Accounts_OtherThan_BankCash() {
    this.lmsService.Get_Acc_Accounts_ForJVandContra({ IsJournal: 1, isAccounting: 0 }).subscribe((res: any) => {
      this.accountHeadDropdown = res;
    });
  }

  Get_Acc_Accounts_By_Tag() {
    this.lmsService
      .Get_Acc_Accounts_By_Tag({
        LoginUserId: this.currentUser.userId,
        Account_Tag: this.Voucher_Tag,
        Voucher_Date: this.VoucherDate || new Date(),
      })
      .subscribe((res: any) => {
        this.accountTagDropdown = res;
      });
  }

  // ======================= EXPORT EXCEL =======================
  exportExcel(mode: 'LoanToAccount' | 'LoanToLoan' | 'AccountToAccount' | 'ReceiptLoan' | 'ReceiptAccountToAccount' | 'PaymentLoanToAccount' | 'PaymentAccountToAccount' | 'PartnerReceipt' | 'PartnerPayment' | 'PartnerJournalLoanToAccount' | 'PartnerJournalLoanToLoan') {
    this.mode = mode;
    if (!this.ChargesHeadDropdown || this.ChargesHeadDropdown.length === 0) {
      this.snackBar.open('Charges Head not loaded yet!', 'Close', { duration: 3000 });
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const sheet1 = workbook.addWorksheet('Sheet1');

    if (mode === 'AccountToAccount') {
      const accountSheet = workbook.addWorksheet('AccountHeads');
      const branchSheet = workbook.addWorksheet('Branches');

      accountSheet.addRow(['Id', 'AccountHead']);
      this.accountHeadDropdown.forEach((item: any) => {
        accountSheet.addRow([item.AccountId, item.Account_Name]);
      });

      branchSheet.addRow(['BranchId', 'BranchName']);
      this.BranchesList.forEach((branch: any) => {
        branchSheet.addRow([branch.BranchId, branch.Branch_Name]);
      });

      sheet1.addRow(['AccountHead', 'Amount', 'TransType', 'Branch']);

      // TransType dropdown
      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`C${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: ['"CR,DR"'],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid TransType',
          error: 'Please select CR or DR'
        };
      }

      // AccountHead dropdown
      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`A${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`AccountHeads!$B$2:$B$${this.accountHeadDropdown.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Account Head',
          error: 'Please select from dropdown'
        };
      }

      // Branch dropdown
      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`D${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`Branches!$B$2:$B$${this.BranchesList.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Branch',
          error: 'Please select a branch'
        };
      }

      accountSheet.state = 'hidden';
      branchSheet.state = 'hidden';
    } else if (mode === 'ReceiptAccountToAccount') {
      const accountSheet = workbook.addWorksheet('AccountHeads');
      const branchSheet = workbook.addWorksheet('Branches');

      accountSheet.addRow(['Id', 'AccountHead']);
      this.accountHeadDropdown.forEach((item: any) => {
        accountSheet.addRow([item.AccountId, item.Account_Name]);
      });

      branchSheet.addRow(['BranchId', 'BranchName']);
      this.BranchesList.forEach((branch: any) => {
        branchSheet.addRow([branch.BranchId, branch.Branch_Name]);
      });

      // No TransType column
      sheet1.addRow(['AccountHead', 'Amount', 'Branch']);

      // AccountHead dropdown
      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`A${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`AccountHeads!$B$2:$B$${this.accountHeadDropdown.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Account Head',
          error: 'Please select from dropdown'
        };
      }

      // Branch dropdown
      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`C${i}`); // Column C (Branch)
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`Branches!$B$2:$B$${this.BranchesList.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Branch',
          error: 'Please select a branch'
        };
      }

      accountSheet.state = 'hidden';
      branchSheet.state = 'hidden';
    }
    else if (mode === 'LoanToLoan') {
      // Existing LoanToLoan logic
      const chargesSheet = workbook.addWorksheet('ChargesHead');
      chargesSheet.addRow(['Id', 'Charges Head Name']);
      this.ChargesHeadDropdown.forEach((item: any) => {
        chargesSheet.addRow([item.Id, item.ChagesHead]);
      });
      sheet1.addRow(['LoanNo', 'Amount', 'ChargesHeadId', 'TransType']);
      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`D${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: ['"CR,DR"'],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Value',
          error: 'Please select CR or DR'
        };
      }
      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`C${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`ChargesHead!$B$2:$B$${this.ChargesHeadDropdown.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Value',
          error: 'Please select from dropdown only'
        };
      }
      chargesSheet.state = 'hidden';
    }
    else if (mode === 'PaymentLoanToAccount') {

      const chargesSheet = workbook.addWorksheet('ChargesHead');
      chargesSheet.addRow(['Id', 'Charges Head Name']);
      this.ChargesHeadDropdown.forEach((item: any) => {
        chargesSheet.addRow([item.Id, item.ChagesHead]);
      });
      sheet1.addRow(['LoanNo', 'Amount', 'ChargesHeadId']);
      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`C${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`ChargesHead!$B$2:$B$${this.ChargesHeadDropdown.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Value',
          error: 'Please select from dropdown only'
        };
      }
      chargesSheet.state = 'hidden';
    }
    else if (mode === 'PaymentAccountToAccount') {
      const accountSheet = workbook.addWorksheet('AccountHeads');
      const branchSheet = workbook.addWorksheet('Branches');

      accountSheet.addRow(['Id', 'AccountHead']);
      this.accountHeadDropdown.forEach((item: any) => {
        accountSheet.addRow([item.AccountId, item.Account_Name]);
      });

      branchSheet.addRow(['BranchId', 'BranchName']);
      this.BranchesList.forEach((branch: any) => {
        branchSheet.addRow([branch.BranchId, branch.Branch_Name]);
      });

      sheet1.addRow(['AccountHead', 'Amount', 'Branch']);

      // AccountHead dropdown
      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`A${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`AccountHeads!$B$2:$B$${this.accountHeadDropdown.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Account Head',
          error: 'Please select from dropdown'
        };
      }

      // Branch dropdown (column C)
      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`C${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`Branches!$B$2:$B$${this.BranchesList.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Branch',
          error: 'Please select a branch'
        };
      }

      accountSheet.state = 'hidden';
      branchSheet.state = 'hidden';
    } else if (mode === 'PartnerReceipt' || mode === 'PartnerPayment') {
      const chargesSheet = workbook.addWorksheet('ChargesHead');
      chargesSheet.addRow(['Id', 'Charges Head Name']);
      this.ChargesHeadDropdown.forEach((item: any) => {
        chargesSheet.addRow([item.Id, item.ChagesHead]);
      });
      // Use "Partner_LoanNo" as column header
      sheet1.addRow(['Partner_LoanNo', 'Amount', 'ChargesHeadId']);
      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`C${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`ChargesHead!$B$2:$B$${this.ChargesHeadDropdown.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Value',
          error: 'Please select from dropdown only'
        };
      }
      chargesSheet.state = 'hidden';
    }
    else if (mode === 'PartnerJournalLoanToAccount') {
      const chargesSheet = workbook.addWorksheet('ChargesHead');
      chargesSheet.addRow(['Id', 'Charges Head Name']);
      this.ChargesHeadDropdown.forEach((item: any) => {
        chargesSheet.addRow([item.Id, item.ChagesHead]);
      });
      sheet1.addRow(['Partner_LoanNo', 'Amount', 'ChargesHeadId']);
      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`C${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`ChargesHead!$B$2:$B$${this.ChargesHeadDropdown.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Value',
          error: 'Please select from dropdown only'
        };
      }
      chargesSheet.state = 'hidden';
    } else if (mode === 'PartnerJournalLoanToLoan') {
      const chargesSheet = workbook.addWorksheet('ChargesHead');
      chargesSheet.addRow(['Id', 'Charges Head Name']);
      this.ChargesHeadDropdown.forEach((item: any) => {
        chargesSheet.addRow([item.Id, item.ChagesHead]);
      });
      sheet1.addRow(['Partner_LoanNo', 'Amount', 'ChargesHeadId', 'TransType']);
      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`D${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: ['"CR,DR"'],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Value',
          error: 'Please select CR or DR'
        };
      }
      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`C${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`ChargesHead!$B$2:$B$${this.ChargesHeadDropdown.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Value',
          error: 'Please select from dropdown only'
        };
      }
      chargesSheet.state = 'hidden';
    }
    else { // LoanToAccount
      const chargesSheet = workbook.addWorksheet('ChargesHead');
      chargesSheet.addRow(['Id', 'Charges Head Name']);
      this.ChargesHeadDropdown.forEach((item: any) => {
        chargesSheet.addRow([item.Id, item.ChagesHead]);
      });
      sheet1.addRow(['LoanNo', 'Amount', 'ChargesHeadId']);
      for (let i = 2; i <= 1000; i++) {
        const cell = sheet1.getCell(`C${i}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: [`ChargesHead!$B$2:$B$${this.ChargesHeadDropdown.length + 1}`],
          showErrorMessage: true,
          errorStyle: 'stop',
          errorTitle: 'Invalid Value',
          error: 'Please select from dropdown only'
        };
      }
      chargesSheet.state = 'hidden';
    }

    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      let fileName = '';
      if (mode === 'LoanToLoan') fileName = 'LoanToLoan_Import.xlsx';
      else if (mode === 'AccountToAccount') fileName = 'AccountToAccount_Import.xlsx';
      else if (mode === 'ReceiptLoan') fileName = 'ReceiptLoan_Import.xlsx';
      else if (mode === 'ReceiptAccountToAccount') fileName = 'ReceiptAccountToAccount_Import.xlsx';
      else if (mode === 'PaymentLoanToAccount') fileName = 'PaymentLoanToAccount_Import.xlsx';
      else if (mode === 'PaymentAccountToAccount') fileName = 'PaymentAccountToAccount_Import.xlsx';
      else if (mode === 'PartnerReceipt') fileName = 'PartnerReceipt_Import.xlsx';
      else if (mode === 'PartnerPayment') fileName = 'PartnerPayment_Import.xlsx';
      else if (mode === 'PartnerJournalLoanToAccount') fileName = 'PartnerJournalLoanToAccount_Import.xlsx';
      else if (mode === 'PartnerJournalLoanToLoan') fileName = 'PartnerJournalLoanToLoan_Import.xlsx';
      else fileName = 'GeneralVoucher_Import.xlsx';
      saveAs(blob, fileName);
    });
  }

  OpenModel(mode: 'LoanToAccount' | 'LoanToLoan' | 'AccountToAccount' | 'ReceiptLoan' | 'ReceiptAccountToAccount' | 'PaymentLoanToAccount' | 'PaymentAccountToAccount' | 'PartnerReceipt' | 'PartnerPayment' | 'PartnerJournalLoanToAccount' | 'PartnerJournalLoanToLoan') {
    this.mode = mode;
    this.resetValidation();
    this.VoucherDate = null;
    this.Remarks = '';
    this.BranchId = '';
    this.Voucher_Tag = '';
    this.DRAccountId = '';
    this.Voucher_Mode_of_Payment = '';
    this.Voucher_Cheque_No = '';
    this.Voucher_Cheque_Date = null;
    this.Voucher_Cheque_Clear_Date = null;
    this.Voucher_Bank_Name = '';
    this.Voucher_E_Ref_No = '';
    this.Voucher_E_Transaction_Date = null;

    if (mode === 'LoanToAccount' || mode === 'PartnerJournalLoanToAccount') {
      this.Account_HeadId = '';
      this.Type = 'CR';
      this.BranchId = '';
    }


    $("#bulkImportModel").modal("show");
    $("#bulkImportModel").css("z-index", "1050");
  }

  onClose() {
    $("#bulkImportModel").modal("hide");
  }

  // ======================= IMPORT EXCEL =======================
  async importExcel(event: any) {
    this.resetValidation();

    const file = event.target.files[0];
    if (!file) return;

    const workbook = new ExcelJS.Workbook();
    const buffer = await file.arrayBuffer();
    await workbook.xlsx.load(buffer);

    const sheet = workbook.getWorksheet('Sheet1');
    if (!sheet) {
      this.snackBar.open('Sheet1 not found!', 'Close', { duration: 3000 });
      return;
    }

    let rawData: any[] = [];

    if (this.mode === 'AccountToAccount') {
      // Parse AccountToAccount columns: AccountHead, Amount, TransType, Branch
      sheet.eachRow((row: any, rowNumber: number) => {
        if (rowNumber === 1) return;
        const accountHead = row.getCell(1).value?.toString().trim() || '';
        const amount = row.getCell(2).value;
        const transType = row.getCell(3)?.value?.toString()?.toUpperCase() || '';
        const branchName = row.getCell(4)?.value?.toString().trim() || '';

        if (!accountHead && !amount && !transType && !branchName) return;

        const matchedAccount = this.accountHeadDropdown.find(
          (x: any) => x.Account_Name?.toString().trim().toLowerCase() === accountHead.toLowerCase()
        );
        const matchedBranch = this.BranchesList.find(
          (x: any) => x.Branch_Name?.toString().trim().toLowerCase() === branchName.toLowerCase()
        );

        const rowData: any = {
          Id: rawData.length + 1,
          AccountHead: accountHead,
          Amount: String(amount || '').trim(),
          TransType: transType,
          BranchName: branchName,
          AccountId: matchedAccount ? matchedAccount.AccountId : null,
          BranchId: matchedBranch ? matchedBranch.BranchId : null
        };
        rawData.push(rowData);
      });
    }
    else if (this.mode === 'ReceiptAccountToAccount' || this.mode === 'PaymentAccountToAccount') {
      sheet.eachRow((row: any, rowNumber: number) => {
        if (rowNumber === 1) return;
        const accountHead = row.getCell(1).value?.toString().trim() || '';
        const amount = row.getCell(2).value;
        const branchName = row.getCell(3)?.value?.toString().trim() || '';

        if (!accountHead && !amount && !branchName) return;

        const matchedAccount = this.accountHeadDropdown.find(
          (x: any) => x.Account_Name?.toString().trim().toLowerCase() === accountHead.toLowerCase()
        );
        const matchedBranch = this.BranchesList.find(
          (x: any) => x.Branch_Name?.toString().trim().toLowerCase() === branchName.toLowerCase()
        );

        const rowData: any = {
          Id: rawData.length + 1,
          AccountHead: accountHead,
          Amount: String(amount || '').trim(),
          BranchName: branchName,
          AccountId: matchedAccount ? matchedAccount.AccountId : null,
          BranchId: matchedBranch ? matchedBranch.BranchId : null,
        };
        rawData.push(rowData);
      });
    }

    else if (this.mode === 'LoanToLoan') {
      // Existing LoanToLoan parsing
      sheet.eachRow((row: any, rowNumber: number) => {
        if (rowNumber === 1) return;
        const loanNo = row.getCell(1).value;
        const amount = row.getCell(2).value;
        const chargesHeadName = row.getCell(3).value;
        const transType = row.getCell(4)?.value?.toString()?.toUpperCase() || '';
        if (!loanNo && !amount && !chargesHeadName && !transType) return;
        const matched = this.ChargesHeadDropdown.find(
          (x: any) => x.ChagesHead?.toString().trim() === chargesHeadName?.toString().trim()
        );
        const rowData: any = {
          Id: rawData.length + 1,
          LoanNo: String(loanNo || '').trim(),
          Amount: String(amount || '').trim(),
          ChargesHead: String(chargesHeadName || '').trim(),
          ChargesHeadId: matched ? matched.Id : null,
          TransType: transType
        };
        rawData.push(rowData);
      });
    }
    else if (this.mode === 'PartnerReceipt' || this.mode === 'PartnerPayment') {
      sheet.eachRow((row: any, rowNumber: number) => {
        if (rowNumber === 1) return;
        const partnerLoanNo = row.getCell(1).value?.toString().trim() || '';
        const amount = row.getCell(2).value;
        const chargesHeadName = row.getCell(3).value;

        if (!partnerLoanNo && !amount && !chargesHeadName) return;

        const matched = this.ChargesHeadDropdown.find(
          (x: any) => x.ChagesHead?.toString().trim() === chargesHeadName?.toString().trim()
        );
        const rowData: any = {
          Id: rawData.length + 1,
          LoanNo: partnerLoanNo,      // map Partner_LoanNo to LoanNo
          Amount: String(amount || '').trim(),
          ChargesHead: String(chargesHeadName || '').trim(),
          ChargesHeadId: matched ? matched.Id : null,
        };
        rawData.push(rowData);
      });
    } else if (this.mode === 'PartnerJournalLoanToAccount') {
      sheet.eachRow((row: any, rowNumber: number) => {
        if (rowNumber === 1) return;
        const partnerLoanNo = row.getCell(1).value?.toString().trim() || '';
        const amount = row.getCell(2).value;
        const chargesHeadName = row.getCell(3).value;

        if (!partnerLoanNo && !amount && !chargesHeadName) return;

        const matched = this.ChargesHeadDropdown.find(
          (x: any) => x.ChagesHead?.toString().trim() === chargesHeadName?.toString().trim()
        );
        const rowData: any = {
          Id: rawData.length + 1,
          LoanNo: partnerLoanNo,
          Amount: String(amount || '').trim(),
          ChargesHead: String(chargesHeadName || '').trim(),
          ChargesHeadId: matched ? matched.Id : null,
        };
        rawData.push(rowData);
      });
    }
    else if (this.mode === 'PartnerJournalLoanToLoan') {
      sheet.eachRow((row: any, rowNumber: number) => {
        if (rowNumber === 1) return;
        const partnerLoanNo = row.getCell(1).value?.toString().trim() || '';
        const amount = row.getCell(2).value;
        const chargesHeadName = row.getCell(3).value;
        const transType = row.getCell(4)?.value?.toString()?.toUpperCase() || '';

        if (!partnerLoanNo && !amount && !chargesHeadName && !transType) return;

        const matched = this.ChargesHeadDropdown.find(
          (x: any) => x.ChagesHead?.toString().trim() === chargesHeadName?.toString().trim()
        );
        const rowData: any = {
          Id: rawData.length + 1,
          LoanNo: partnerLoanNo,
          Amount: String(amount || '').trim(),
          ChargesHead: String(chargesHeadName || '').trim(),
          ChargesHeadId: matched ? matched.Id : null,
          TransType: transType
        };
        rawData.push(rowData);
      });
    }
    else { // LoanToAccount
      sheet.eachRow((row: any, rowNumber: number) => {
        if (rowNumber === 1) return;
        const loanNo = row.getCell(1).value;
        const amount = row.getCell(2).value;
        const chargesHeadName = row.getCell(3).value;
        if (!loanNo && !amount && !chargesHeadName) return;
        const matched = this.ChargesHeadDropdown.find(
          (x: any) => x.ChagesHead?.toString().trim() === chargesHeadName?.toString().trim()
        );
        const rowData: any = {
          Id: rawData.length + 1,
          LoanNo: String(loanNo || '').trim(),
          Amount: String(amount || '').trim(),
          ChargesHead: String(chargesHeadName || '').trim(),
          ChargesHeadId: matched ? matched.Id : null
        };
        rawData.push(rowData);
      });
    }

    if (rawData.length === 0) {
      this.snackBar.openFromComponent(SnackbarComponent, { data: 'No data found in Excel file!', ...this.configSuccess });
      event.target.value = null;
      return;
    }

    this.UIValidationFailed = this.validateUIRows(rawData);

    if (this.UIValidationFailed.length > 0) {
      this.showUIValidationTable();
      const fileInput = document.getElementById('bulkImport') as HTMLInputElement;
      if (fileInput) fileInput.value = '';
    } else {
      this.processValidData(rawData);
    }

    event.target.value = null;
  }
  private validateUIRows(data: any[]): any[] {

    const allowedUnlimitedModes = ['PaymentLoanToAccount', 'PartnerPayment', 'PaymentAccountToAccount'];
    if (data.length > 50 && !allowedUnlimitedModes.includes(this.mode)) {
      this.snackBar.openFromComponent(SnackbarComponent, { data: 'Max row of data import is 50!', ...this.configSuccess });
      return data.map(row => ({
        ...row,
        maxRowLimitError: true
      }));
    }

    const failedRows: any[] = [];

    data.forEach((row) => {
      const errorFlags: any = {};
      if (this.mode === 'AccountToAccount') {
        if (!row.AccountHead || !row.AccountId) errorFlags.accountHeadError = true;
        if (!row.Amount || isNaN(Number(row.Amount)) || Number(row.Amount) <= 0) errorFlags.amountError = true;
        if (!row.TransType || (row.TransType !== 'CR' && row.TransType !== 'DR')) errorFlags.transTypeError = true;
        if (!row.BranchName || !row.BranchId) errorFlags.branchError = true;
      }
      else if (this.mode === 'ReceiptAccountToAccount') {
        if (!row.AccountHead || !row.AccountId) errorFlags.accountHeadError = true;
        if (!row.Amount || isNaN(Number(row.Amount)) || Number(row.Amount) <= 0) errorFlags.amountError = true;
        if (!row.BranchName || !row.BranchId) errorFlags.branchError = true;
      }
      else if (this.mode === 'LoanToLoan') {
        if (!row.LoanNo || row.LoanNo.trim() === '') errorFlags.loanNoError = true;
        if (!row.Amount || isNaN(Number(row.Amount)) || Number(row.Amount) <= 0) errorFlags.amountError = true;
        if (!row.ChargesHead || row.ChargesHead.trim() === '' || !row.ChargesHeadId) errorFlags.chargesHeadError = true;
        if (!row.TransType || (row.TransType !== 'CR' && row.TransType !== 'DR')) errorFlags.transTypeError = true;
      }
      else if (this.mode === 'LoanToAccount' || this.mode === 'ReceiptLoan') {
        if (!row.LoanNo || row.LoanNo.trim() === '') errorFlags.loanNoError = true;
        if (!row.Amount || isNaN(Number(row.Amount)) || Number(row.Amount) <= 0) errorFlags.amountError = true;
        if (!row.ChargesHead || row.ChargesHead.trim() === '' || !row.ChargesHeadId) errorFlags.chargesHeadError = true;
      }
      else if (this.mode === 'PaymentLoanToAccount') {
        if (!row.LoanNo || row.LoanNo.trim() === '') errorFlags.loanNoError = true;
        if (!row.Amount || isNaN(Number(row.Amount)) || Number(row.Amount) <= 0) errorFlags.amountError = true;
        if (!row.ChargesHead || row.ChargesHead.trim() === '' || !row.ChargesHeadId) errorFlags.chargesHeadError = true;
      }
      else if (this.mode === 'PaymentAccountToAccount') {
        if (!row.AccountHead || !row.AccountId) errorFlags.accountHeadError = true;
        if (!row.Amount || isNaN(Number(row.Amount)) || Number(row.Amount) <= 0) errorFlags.amountError = true;
        if (!row.BranchName || !row.BranchId) errorFlags.branchError = true;
      } else if (this.mode === 'PartnerReceipt' || this.mode === 'PartnerPayment') {
        if (!row.LoanNo || row.LoanNo.trim() === '') errorFlags.loanNoError = true;
        if (!row.Amount || isNaN(Number(row.Amount)) || Number(row.Amount) <= 0) errorFlags.amountError = true;
        if (!row.ChargesHead || row.ChargesHead.trim() === '' || !row.ChargesHeadId) errorFlags.chargesHeadError = true;
      } else if (this.mode === 'PartnerJournalLoanToAccount') {
        if (!row.LoanNo || row.LoanNo.trim() === '') errorFlags.loanNoError = true;
        if (!row.Amount || isNaN(Number(row.Amount)) || Number(row.Amount) <= 0) errorFlags.amountError = true;
        if (!row.ChargesHead || row.ChargesHead.trim() === '' || !row.ChargesHeadId) errorFlags.chargesHeadError = true;
      }
      else if (this.mode === 'PartnerJournalLoanToLoan') {
        if (!row.LoanNo || row.LoanNo.trim() === '') errorFlags.loanNoError = true;
        if (!row.Amount || isNaN(Number(row.Amount)) || Number(row.Amount) <= 0) errorFlags.amountError = true;
        if (!row.ChargesHead || row.ChargesHead.trim() === '' || !row.ChargesHeadId) errorFlags.chargesHeadError = true;
        if (!row.TransType || (row.TransType !== 'CR' && row.TransType !== 'DR')) errorFlags.transTypeError = true;
      }

      if (Object.keys(errorFlags).length > 0) {
        failedRows.push({ ...row, ...errorFlags });
      }
    });

    return failedRows;
  }
  private showUIValidationTable() {
    if (this.mode === 'LoanToLoan') {
      this.displayedColumnsUIValidation = ["Id", "LoanNo", "Amount", "ChargesHead", "TransType"];
    } else if (this.mode === 'AccountToAccount') {
      this.displayedColumnsUIValidation = ["Id", "AccountHead", "Amount", "TransType", "BranchName"];
    }
    else if (this.mode === 'ReceiptLoan' || this.mode === 'LoanToAccount') {
      this.displayedColumnsUIValidation = ["Id", "LoanNo", "Amount", "ChargesHead"];
    }
    else if (this.mode === 'ReceiptAccountToAccount') {
      this.displayedColumnsUIValidation = ["Id", "AccountHead", "Amount", "BranchName"];
    } else if (this.mode === 'PaymentLoanToAccount') {
      this.displayedColumnsUIValidation = ["Id", "LoanNo", "Amount", "ChargesHead"];
    }
    else if (this.mode === 'PaymentAccountToAccount') {
      this.displayedColumnsUIValidation = ["Id", "AccountHead", "Amount", "BranchName"];
    } else if (this.mode === 'PartnerReceipt' || this.mode === 'PartnerPayment') {
      this.displayedColumnsUIValidation = ["Id", "LoanNo", "Amount", "ChargesHead"];
    } else if (this.mode === 'PartnerJournalLoanToAccount') {
      this.displayedColumnsUIValidation = ["Id", "LoanNo", "Amount", "ChargesHead"];
    }
    else if (this.mode === 'PartnerJournalLoanToLoan') {
      this.displayedColumnsUIValidation = ["Id", "LoanNo", "Amount", "ChargesHead", "TransType"];
    }
    console.log("this.UIValidationFailed", this.UIValidationFailed);
    this.dataSourceUIValidation = new MatTableDataSource(this.UIValidationFailed);
    $("#bulkImportModel").modal("show");
  }

  private processValidData(data: any[]) {
    let JsonData: any;
    // Convert date to local string WITHOUT timezone shift
    const formatLocalDate = (date: any): string => {
      if (!date) return null;
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const voucherDate = formatLocalDate(this.VoucherDate);
    if (this.mode === 'AccountToAccount') {
      const finalData = data.map(row => ({
        AccountId: row.AccountId,
        Amount: Number(row.Amount),
        TransType: row.TransType,
        BranchId: row.BranchId
      }));
      JsonData = {
        VoucherDate: voucherDate,
        Voucher_Narration: this.Remarks,
        AccountDetails: finalData
      };
    }
    else if (this.mode === 'LoanToLoan') {
      const finalData = data.map(row => ({
        LoanNo: row.LoanNo,
        Amount: Number(row.Amount),
        ChargesHeadId: row.ChargesHeadId,
        TransType: row.TransType,
      }));
      JsonData = {
        VoucherDate: voucherDate,
        Voucher_Narration: this.Remarks,
        LoanDetails: finalData
      };
    }
    else if (this.mode === 'LoanToAccount') {
      const finalData = data.map(row => ({
        LoanNo: row.LoanNo,
        Amount: Number(row.Amount),
        ChargesHeadId: row.ChargesHeadId,
      }));
      JsonData = {
        VoucherDate: voucherDate,
        AccountId: Number(this.Account_HeadId),
        TransType: this.Type,
        BranchId: Number(this.BranchId),
        Voucher_Narration: this.Remarks,
        LoanDetails: finalData
      };
    }
    else if (this.mode === 'ReceiptLoan') {
      const finalData = data.map(row => ({
        LoanNo: row.LoanNo,
        Amount: Number(row.Amount),
        ChargesHeadId: row.ChargesHeadId,
      }));

      JsonData = {
        VoucherDate: voucherDate,
        AccountId: Number(this.DRAccountId),
        Voucher_Tag: this.Voucher_Tag,
        PaymentMode: this.Voucher_Mode_of_Payment,
        RefNo: this.Voucher_E_Ref_No || "",
        TransactionDate: this.Voucher_E_Transaction_Date || "",
        ChequeNo: this.Voucher_Cheque_No || "",
        ChequeDate: this.Voucher_Cheque_Date || "",
        ChequeClearDate: this.Voucher_Cheque_Clear_Date || "",
        BankName: this.Voucher_Bank_Name || "",
        Voucher_Narration: this.Remarks,
        LoanDetails: finalData
      };
    }
    else if (this.mode === 'ReceiptAccountToAccount') {
      const finalData = data.map(row => ({
        AccountId: row.AccountId,
        Amount: Number(row.Amount),
        BranchId: row.BranchId
      }));

      JsonData = {
        VoucherDate: voucherDate,
        AccountId: Number(this.DRAccountId),
        Voucher_Tag: this.Voucher_Tag,
        PaymentMode: this.Voucher_Mode_of_Payment,
        RefNo: this.Voucher_E_Ref_No || "",
        TransactionDate: this.Voucher_E_Transaction_Date || "",
        ChequeNo: this.Voucher_Cheque_No || "",
        ChequeDate: this.Voucher_Cheque_Date || "",
        ChequeClearDate: this.Voucher_Cheque_Clear_Date || "",
        BankName: this.Voucher_Bank_Name || "",
        Voucher_Narration: this.Remarks,
        AccountDetails: finalData
      };
    } else if (this.mode === 'PaymentLoanToAccount') {
      const finalData = data.map(row => ({
        LoanNo: row.LoanNo,
        Amount: Number(row.Amount),
        ChargesHeadId: row.ChargesHeadId,
      }));
      JsonData = {
        VoucherDate: voucherDate,
        AccountId: Number(this.DRAccountId),
        Voucher_Tag: this.Voucher_Tag,
        PaymentMode: this.Voucher_Mode_of_Payment,
        RefNo: this.Voucher_E_Ref_No || "",
        TransactionDate: this.Voucher_E_Transaction_Date || "",
        ChequeNo: this.Voucher_Cheque_No || "",
        ChequeDate: this.Voucher_Cheque_Date || "",
        ChequeClearDate: this.Voucher_Cheque_Clear_Date || "",
        BankName: this.Voucher_Bank_Name || "",
        Voucher_Narration: this.Remarks,
        LoanDetails: finalData
      };
    }
    else if (this.mode === 'PaymentAccountToAccount') {
      const finalData = data.map(row => ({
        AccountId: row.AccountId,
        Amount: Number(row.Amount),
        BranchId: row.BranchId,
      }));
      JsonData = {
        VoucherDate: voucherDate,
        AccountId: Number(this.DRAccountId),
        Voucher_Tag: this.Voucher_Tag,
        PaymentMode: this.Voucher_Mode_of_Payment,
        RefNo: this.Voucher_E_Ref_No || "",
        TransactionDate: this.Voucher_E_Transaction_Date || "",
        ChequeNo: this.Voucher_Cheque_No || "",
        ChequeDate: this.Voucher_Cheque_Date || "",
        ChequeClearDate: this.Voucher_Cheque_Clear_Date || "",
        BankName: this.Voucher_Bank_Name || "",
        Voucher_Narration: this.Remarks,
        AccountDetails: finalData
      };
    } else if (this.mode === 'PartnerReceipt') {
      const finalData = data.map(row => ({
        LoanNo: row.LoanNo,
        Amount: Number(row.Amount),
        ChargesHeadId: row.ChargesHeadId,
      }));
      JsonData = {
        VoucherDate: voucherDate,
        AccountId: Number(this.DRAccountId),
        Voucher_Tag: this.Voucher_Tag,
        PaymentMode: this.Voucher_Mode_of_Payment,
        RefNo: this.Voucher_E_Ref_No || "",
        TransactionDate: this.Voucher_E_Transaction_Date || "",
        ChequeNo: this.Voucher_Cheque_No || "",
        ChequeDate: this.Voucher_Cheque_Date || "",
        ChequeClearDate: this.Voucher_Cheque_Clear_Date || "",
        BankName: this.Voucher_Bank_Name || "",
        Voucher_Narration: this.Remarks,
        LoanDetails: finalData
      };
    }
    else if (this.mode === 'PartnerPayment') {
      const finalData = data.map(row => ({
        LoanNo: row.LoanNo,
        Amount: Number(row.Amount),
        ChargesHeadId: row.ChargesHeadId,
      }));
      JsonData = {
        VoucherDate: voucherDate,
        AccountId: Number(this.DRAccountId),
        Voucher_Tag: this.Voucher_Tag,
        PaymentMode: this.Voucher_Mode_of_Payment,
        RefNo: this.Voucher_E_Ref_No || "",
        TransactionDate: this.Voucher_E_Transaction_Date || "",
        ChequeNo: this.Voucher_Cheque_No || "",
        ChequeDate: this.Voucher_Cheque_Date || "",
        ChequeClearDate: this.Voucher_Cheque_Clear_Date || "",
        BankName: this.Voucher_Bank_Name || "",
        Voucher_Narration: this.Remarks,
        LoanDetails: finalData
      };
    } else if (this.mode === 'PartnerJournalLoanToAccount') {
      const finalData = data.map(row => ({
        LoanNo: row.LoanNo,
        Amount: Number(row.Amount),
        ChargesHeadId: row.ChargesHeadId,
      }));
      JsonData = {
        VoucherDate: voucherDate,
        AccountId: Number(this.Account_HeadId),
        TransType: this.Type,
        BranchId: Number(this.BranchId),
        Voucher_Narration: this.Remarks,
        LoanDetails: finalData
      };
    } else if (this.mode === 'PartnerJournalLoanToLoan') {
      const finalData = data.map(row => ({
        LoanNo: row.LoanNo,
        Amount: Number(row.Amount),
        ChargesHeadId: row.ChargesHeadId,
        TransType: row.TransType,
      }));
      JsonData = {
        VoucherDate: voucherDate,
        Voucher_Narration: this.Remarks,
        LoanDetails: finalData
      };
    }
    let checkApi;
    if (this.mode === 'LoanToLoan') {
      checkApi = this._MasterService.Journal_Voucher_Check_LoantoLoan_Import({ JsonData: JSON.stringify(JsonData) });
    } else if (this.mode === 'AccountToAccount') {
      checkApi = this._MasterService.Journal_Voucher_Check_AccountToAccount_Import({ JsonData: JSON.stringify(JsonData) });
    } else if (this.mode === 'ReceiptLoan') {
      checkApi = this._MasterService.Receipt_Voucher_Check_LoantoAccount_Import({ JsonData: JSON.stringify(JsonData) });
    } else if (this.mode === 'ReceiptAccountToAccount') {
      checkApi = this._MasterService.Receipt_Voucher_Check_AccounttoAccount_Import({ JsonData: JSON.stringify(JsonData) });
    } else if (this.mode === 'PaymentLoanToAccount') {
      checkApi = this._MasterService.Payment_Voucher_Check_LoantoAccount_Import({ JsonData: JSON.stringify(JsonData) });
    }
    else if (this.mode === 'PaymentAccountToAccount') {
      checkApi = this._MasterService.Payment_Voucher_Check_AccounttoAccount_Import({ JsonData: JSON.stringify(JsonData) });
    } else if (this.mode === 'PartnerReceipt') {
      checkApi = this._MasterService.Partner_Receipt_Voucher_Check_Import({ JsonData: JSON.stringify(JsonData) });
    }
    else if (this.mode === 'PartnerPayment') {
      checkApi = this._MasterService.Partner_Payment_Voucher_Check_Import({ JsonData: JSON.stringify(JsonData) });
    } else if (this.mode === 'PartnerJournalLoanToAccount') {
      checkApi = this._MasterService.Partner_Journal_Voucher_Check_LoantoAccount_Import({ JsonData: JSON.stringify(JsonData) });
    }
    else if (this.mode === 'PartnerJournalLoanToLoan') {
      checkApi = this._MasterService.Partner_Journal_Voucher_Check_LoantoLoan_Import({ JsonData: JSON.stringify(JsonData) });
    }
    else {
      checkApi = this._MasterService.Journal_Voucher_Check_LoantoAccount_Import({ JsonData: JSON.stringify(JsonData) });
    }


    checkApi.subscribe((res: any) => {
      if (res && res.length > 0) {
        // Map backend fields to what the template expects
        this.UnmatchedData = res.map((item: any) => ({
          ...item,
          AccountHead: item.AccountName || item.AccountHead || '',
          LoanNo: item.LoanNo || ''
        }));
        this.UnmatcheddisplayedColumns = ["Id",
          (this.mode === 'AccountToAccount' || this.mode === 'ReceiptAccountToAccount' || this.mode === 'PaymentAccountToAccount') ? "AccountHead" : "LoanNo",
          "ErrorReason"
        ]; this.dataSourceUnmatched = new MatTableDataSource(this.UnmatchedData);
      } else {
        let getApi;
        if (this.mode === 'LoanToLoan') {
          getApi = this._MasterService.Journal_Voucher_Get_LoantoLoan_Import({ JsonData: JSON.stringify(JsonData) });
        } else if (this.mode === 'AccountToAccount') {
          getApi = this._MasterService.Journal_Voucher_Get_AccountToAccount_Import({ JsonData: JSON.stringify(JsonData) });
        } else if (this.mode === 'LoanToAccount') {
          getApi = this._MasterService.Journal_Voucher_Get_LoantoAccount_Import({ JsonData: JSON.stringify(JsonData) });
        } else if (this.mode === 'ReceiptLoan') {
          getApi = this._MasterService.Receipt_Voucher_Get_LoantoAccount_Import({ JsonData: JSON.stringify(JsonData) });
        }
        else if (this.mode === 'ReceiptAccountToAccount') {
          getApi = this._MasterService.Receipt_Voucher_Get_AccounttoAccount_Import({ JsonData: JSON.stringify(JsonData) });
        } else if (this.mode === 'PaymentLoanToAccount') {
          getApi = this._MasterService.Payment_Voucher_Get_LoantoAccount_Import({ JsonData: JSON.stringify(JsonData) });
        }
        else if (this.mode === 'PaymentAccountToAccount') {
          getApi = this._MasterService.Payment_Voucher_Get_AccounttoAccount_Import({ JsonData: JSON.stringify(JsonData) });
        } else if (this.mode === 'PartnerReceipt') {
          getApi = this._MasterService.Partner_Receipt_Voucher_Get_Import({ JsonData: JSON.stringify(JsonData) });
        }
        else if (this.mode === 'PartnerPayment') {
          getApi = this._MasterService.Partner_Payment_Voucher_Get_Import({ JsonData: JSON.stringify(JsonData) });
        } else if (this.mode === 'PartnerJournalLoanToAccount') {
          getApi = this._MasterService.Partner_Journal_Voucher_Get_LoantoAccount_Import({ JsonData: JSON.stringify(JsonData) });
        }
        else if (this.mode === 'PartnerJournalLoanToLoan') {
          getApi = this._MasterService.Partner_Journal_Voucher_Get_LoantoLoan_Import({ JsonData: JSON.stringify(JsonData) });
        }


        getApi.subscribe((res: any) => {
          this.voucherMasterdata = res.Item1[0];
          this.voucherDetaildata = res.Item2;

          if (this.mode === 'AccountToAccount' || this.mode === 'ReceiptAccountToAccount' || this.mode === 'PaymentAccountToAccount') {
            // For accounting voucher, set DR/CR amounts
            this.voucherDetaildata.forEach((x: any) => {
              x.AmountDR = x.TranType === 'DR' ? x.Amount : 0;
              x.AmountCR = x.TranType === 'CR' ? x.Amount : 0;
            });
            this.dataSourceVoucher = new MatTableDataSource(this.voucherDetaildata);
            this.displayedAccountingColumns = ['AccountHead', 'Branch', 'AmountDR', 'AmountCR'];
          }
          else {
            // For loan-based vouchers (LoanToAccount, LoanToLoan, ReceiptLoan)
            this.voucherDetaildata.forEach((x: any) => {
              x.AmountDR = x.TranType === 'DR' ? x.Amount : 0;
              x.AmountCR = x.TranType === 'CR' ? x.Amount : 0;
            });
            this.dataSourceVoucher = new MatTableDataSource(this.voucherDetaildata);
            this.displayedVoucherColumns = [
              'Type', 'CaseNo', 'Customer', 'Branch', 'Category', 'AccountHead', 'AmountDR', 'AmountCR'
            ];
          }

          this.MainPayload = JsonData;
          $("#voucherDetailModel").modal("show");
          $('#voucherDetailModel').css('z-index', '1051');
        });
      }
    });
  }

  OnSaveVoucher() {
    let saveApi;
    if (this.mode === 'LoanToLoan') {
      saveApi = this._MasterService.Journal_Voucher_Save_LoantoLoan_Import({ JsonData: JSON.stringify(this.MainPayload), LoginUserId: this.currentUser.userId });
    } else if (this.mode === 'AccountToAccount') {
      saveApi = this._MasterService.Journal_Voucher_Save_AccountToAccount_Import({ JsonData: JSON.stringify(this.MainPayload), LoginUserId: this.currentUser.userId });
    } else if (this.mode === 'LoanToAccount') {
      saveApi = this._MasterService.Journal_Voucher_Save_LoantoAccount_Import({ JsonData: JSON.stringify(this.MainPayload), LoginUserId: this.currentUser.userId });
    }
    else if (this.mode === 'ReceiptLoan') {
      saveApi = this._MasterService.Receipt_Voucher_Save_LoantoAccount_Import({ JsonData: JSON.stringify(this.MainPayload), LoginUserId: this.currentUser.userId });
    }
    else if (this.mode === 'ReceiptAccountToAccount') {
      saveApi = this._MasterService.Receipt_Voucher_Save_AccounttoAccount_Import({ JsonData: JSON.stringify(this.MainPayload), LoginUserId: this.currentUser.userId });
    } else if (this.mode === 'PaymentLoanToAccount') {
      saveApi = this._MasterService.Payment_Voucher_Save_LoantoAccount_Import({ JsonData: JSON.stringify(this.MainPayload), LoginUserId: this.currentUser.userId });
    }
    else if (this.mode === 'PaymentAccountToAccount') {
      saveApi = this._MasterService.Payment_Voucher_Save_AccounttoAccount_Import({ JsonData: JSON.stringify(this.MainPayload), LoginUserId: this.currentUser.userId });
    } else if (this.mode === 'PartnerReceipt') {
      saveApi = this._MasterService.Partner_Receipt_Voucher_Save_Import({ JsonData: JSON.stringify(this.MainPayload), LoginUserId: this.currentUser.userId });
    }
    else if (this.mode === 'PartnerPayment') {
      saveApi = this._MasterService.Partner_Payment_Voucher_Save_Import({ JsonData: JSON.stringify(this.MainPayload), LoginUserId: this.currentUser.userId });
    } else if (this.mode === 'PartnerJournalLoanToAccount') {
      saveApi = this._MasterService.Partner_Journal_Voucher_Save_LoantoAccount_Import({ JsonData: JSON.stringify(this.MainPayload), LoginUserId: this.currentUser.userId });
    }
    else if (this.mode === 'PartnerJournalLoanToLoan') {
      saveApi = this._MasterService.Partner_Journal_Voucher_Save_LoantoLoan_Import({ JsonData: JSON.stringify(this.MainPayload), LoginUserId: this.currentUser.userId });
    }

    saveApi.subscribe((res: any) => {
      this.OnCloseVoucher();
      this.onClose();
      this.showSpinner = true;
      if (res[0].CODE > 0) {
        this.snackBar.openFromComponent(SnackbarComponent, { data: res[0].Msg, ...this.configSuccess });
        this.showSpinner = false;

      } else {
        this.snackBar.openFromComponent(SnackbarComponent, { data: res[0].Msg, ...this.configSuccess });
        this.showSpinner = false;
      }
    });
  }

  calculateTranTypeCR() {
    if (this.voucherDetaildata) {
      let sum = 0.00;
      for (let i = 0; i < this.voucherDetaildata.length; i++) {
        sum += Number(this.voucherDetaildata[i]["AmountCR"]);
      }
      return sum.toFixed(2);
    }
    return 0;
  }

  calculateTranTypeDR() {
    if (this.voucherDetaildata) {
      let sum = 0.00;
      for (let i = 0; i < this.voucherDetaildata.length; i++) {
        sum += Number(this.voucherDetaildata[i]["AmountDR"]);
      }
      return sum.toFixed(2);
    }
    return 0;
  }

  private resetValidation() {
    this.UIValidationFailed = [];
    this.dataSourceUIValidation = new MatTableDataSource([]);
    this.dataSourceUnmatched = null;
  }

  OnCloseVoucher() {
    $("#voucherDetailModel").modal("hide");
  }
}